import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/yangwei/work/project/cat_help_admin/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import Vue from 'vue';
Vue.directive('dragMove', {
  inserted: function inserted(el, bindings, vnode) {
    el.onmousedown = function (e) {
      e.stopPropagation();
      var boxWidth = el.offsetWidth;
      var boxHeight = el.offsetHeight;
      var disX = e.pageX - el.offsetLeft;
      var disY = e.pageY - el.offsetTop;
      document.onmousemove = function (e) {
        e.preventDefault();
        if (e.pageY - disY >= 0 && e.pageY - disY <= bindings.value.outBoxSize.h - boxHeight) {
          el.style.top = e.pageY - disY + 'px';
        }
        if (e.pageX - disX >= 0 && e.pageX - disX <= bindings.value.outBoxSize.w - boxWidth) {
          el.style.left = e.pageX - disX + 'px';
        }
        bindings.value.setPosition({
          left: parseFloat(el.style.left),
          top: parseFloat(el.style.top),
          index: bindings.value.outBoxSize.index,
          cId: bindings.value.outBoxSize.cId
        });
        // el.style.top  = e.pageY - disY + 'px';
        // el.style.left = e.pageX - disX + 'px';
        // 通过传参的形式，将methods中的函数传进来，以此来改变data中的值
        // bindings.value.setPosition(el.style.left, e.pageY-disY)
      };

      document.onmouseup = function () {
        document.onmousemove = document.onmouseup = null;
      };
    };
  }
});
Vue.directive('dragEagle', {
  inserted: function inserted(el, bindings, vnode) {
    el.onmousedown = function (e) {
      e.stopPropagation();
      var PNode = el.parentNode;
      //得到点击时该容器的宽高：
      var targetDivWidth = PNode.offsetWidth;
      var targetDivHeight = PNode.offsetHeight;
      var targetDivLeft = PNode.offsetLeft;
      var targetDivTop = PNode.offsetTop;
      var startX = e.clientX;
      var startY = e.clientY;
      document.onmousemove = function (e) {
        e.preventDefault();
        //得到鼠标拖动的宽高距离：取绝对值
        var distX = Math.abs(e.clientX - startX);
        var distY = Math.abs(e.clientY - startY);
        if (e.clientX >= startX && e.clientY >= startY && targetDivWidth + distX + targetDivLeft <= bindings.value.outBoxSize.w && targetDivHeight + distY + targetDivTop <= bindings.value.outBoxSize.h) {
          //往右下方拖动(处理不超出)：
          PNode.style.width = targetDivWidth + distX + "px";
          PNode.style.height = targetDivHeight + distY + "px";
        } else if (e.clientX < startX && e.clientY < startY) {
          //往左上方拖动：
          PNode.style.width = targetDivWidth - distX + "px";
          PNode.style.height = targetDivHeight - distY + "px";
        }

        //设置最大最小范围：不能无限制缩放，影响体验
        if (parseInt(PNode.style.width) >= 500) {
          PNode.style.width = 500 + "px";
        }
        if (parseInt(PNode.style.width) <= 50) {
          PNode.style.width = 50 + "px";
        }
        if (parseInt(PNode.style.height) >= 500) {
          PNode.style.height = 500 + "px";
        }
        if (parseInt(PNode.style.height) <= 50) {
          PNode.style.height = 50 + "px";
        }
        // console.log(that.$refs.dragBox.getBoundingClientRect(), "数据")
        bindings.value.setPosition({
          left: parseFloat(PNode.style.left),
          top: parseFloat(PNode.style.top),
          index: bindings.value.outBoxSize.index,
          cId: bindings.value.outBoxSize.cId
        });
      };
      document.onmouseup = function () {
        document.onmousemove = null;
      };
    };
  }
});
//自定义focus
Vue.directive('focus', {
  inserted: function inserted(el) {
    el.focus();
  }
});
//自定义scrollerUpdate
Vue.directive('scrollUpdate', {
  inserted: function inserted(el, binding, vnode, oldVnode) {
    var touchStarY = 0,
      touchEndY = 0,
      touchDistance = 0,
      pageDownTimer = null,
      newLiEle = null,
      updateState = 0;
    el.addEventListener('touchstart', /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              touchStarY = e.touches[0].clientY;
              clearInterval(pageDownTimer);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    el.addEventListener('touchmove', /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(e) {
        var UpdateEle;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              touchEndY = e.touches[0].clientY;
              touchDistance = touchEndY - touchStarY;
              //console.log("touch滑动了", touchDistance);
              UpdateEle = document.getElementById("downUpdateEle");
              if (touchDistance < 0) {
                //上拉
                if (UpdateEle) el.removeChild(newLiEle);
              } else {
                if (el.scrollTop == 0) {
                  e.preventDefault();
                  if (!UpdateEle) {
                    //添加 li
                    newLiEle = document.createElement("li");
                    // 设置 li 属性： id、style；
                    newLiEle.setAttribute("id", "downUpdateEle");
                    newLiEle.setAttribute('style', 'list-style: none; background: #fefefe; color: #999999; font-size: 16px; opacity: 1;');
                    newLiEle.innerHTML = "下拉刷新";
                    el.insertBefore(newLiEle, el.firstChild);
                  }
                  newLiEle.style.lineHeight = touchDistance + 'px';
                  if (touchDistance > 40) {
                    newLiEle.innerHTML = "松开刷新";
                    newLiEle.style.lineHeight = '40px';
                    updateState = 1;
                  }
                }
              }
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }());
    el.addEventListener('touchend', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var expression_name, expression_fun, resetNewTopEle;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            resetNewTopEle = function _resetNewTopEle() {
              pageDownTimer = setInterval(function () {
                if (document.getElementById("downUpdateEle")) {
                  //样式获取
                  var newLiLineheight = parseInt(newLiEle.style.lineHeight);
                  var newLiFontSize = parseInt(newLiEle.style.fontSize);
                  var newLiOpacity = newLiEle.style.opacity;
                  if (newLiLineheight < 1) {
                    el.removeChild(newLiEle);
                    clearInterval(pageDownTimer);
                  } else {
                    newLiEle.style.lineHeight = newLiLineheight / 2 + 'px';
                    newLiEle.style.fontSize = newLiFontSize / 2 + 'px';
                    newLiEle.style.opacity = newLiOpacity / 2;
                  }
                }
              }, 70);
            };
            if (!(updateState == 1)) {
              _context3.next = 12;
              break;
            }
            //刷新数据；
            expression_name = binding.expression;
            expression_fun = vnode.context[expression_name];
            _context3.t0 = expression_fun;
            if (!_context3.t0) {
              _context3.next = 8;
              break;
            }
            _context3.next = 8;
            return expression_fun();
          case 8:
            updateState = 0;
            resetNewTopEle();
            _context3.next = 13;
            break;
          case 12:
            //不触发刷新数据
            resetNewTopEle();
          case 13:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    })));
  }
});
//自定义scrollMore
Vue.directive('scrollMore', {
  inserted: function inserted(el, binding, vnode, oldVnode) {
    //console.log(el, binding, vnode)
    var scrollHeight = el.offsetHeight,
      expression_name = binding.expression,
      expression_fun = vnode.context[expression_name];
    var scrollTop_old = 0,
      scrollTop_new = 0;
    el.addEventListener('scroll', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            scrollTop_old = scrollTop_new;
            scrollTop_new = el.scrollTop;
            //向下滑动的时候阻止触发加载；
            if (!(scrollTop_old > scrollTop_new)) {
              _context4.next = 4;
              break;
            }
            return _context4.abrupt("return", false);
          case 4:
            if (!(scrollHeight + el.scrollTop + 10 >= el.firstChild.clientHeight)) {
              _context4.next = 16;
              break;
            }
            _context4.prev = 5;
            console.log("加载了.....");
            _context4.t0 = expression_fun;
            if (!_context4.t0) {
              _context4.next = 11;
              break;
            }
            _context4.next = 11;
            return expression_fun();
          case 11:
            _context4.next = 16;
            break;
          case 13:
            _context4.prev = 13;
            _context4.t1 = _context4["catch"](5);
            console.log(_context4.t1);
          case 16:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[5, 13]]);
    })));
  }
});
//自定义title
Vue.directive('title', {
  inserted: function inserted(el, binding) {
    console.log("binding:", binding); //binding.name是指令的名称不包含v-
    el.innerHTML = binding.value;
  }
});